// this.$store.state.aptitudes
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import _ from "lodash";
import { colecciones } from "../constantes";

// APTITUDES
export const aptitudes = {
  aptitudFisica: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idEmpresa: "",
          idConductor: "",
          idPlanDesplazamiento: "",
          formato: {
            id: "",
            secciones: [],
          },
          tipo: "Física",
          resultado: "Pendiente",
          registro: {
            tipo: "Online",
            idUsuario: "",
            filtro: moment().format("YYYY-MM-DD"),
            realizacion: {
              fecha: moment().format("YYYY-MM-DD"),
              hora: moment().format("hh:mm:ss A"),
            },
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            sincronizacion: serverTimestamp(),
            estado: "Creado",
          },
        };
      }
    },
    funciones: {
      async crear(aptitud, modoSinConexion, coleccion) {
        if (modoSinConexion) {
          aptitud.registro.tipo = "Offline";
          const obtenerRegistros = await localforage.getItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.aptitudes.registros,
          );
          const copia = obtenerRegistros
            ? JSON.parse(JSON.stringify(obtenerRegistros))
            : [];
          const registros = obtenerRegistros
            ? copia.concat([aptitud])
            : [aptitud];
          await localforage.setItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.aptitudes.registros,
            registros,
          );
        } else {
          await setDoc(
            doc(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.seguridadVial.aptitudes.registros,
              aptitud.id,
            ),
            aptitud,
          );
        }
      },
      async actualizar(aptitud, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.aptitudes.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === aptitud.id)
            : -1;
          if (index !== -1) {
            registros[index] = aptitud;
            await localforage.setItem(
              colecciones.localforage.seguridadVial.aptitudes.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.aptitudes.registros,
              aptitud.id,
            ),
            aptitud,
          );
        }
      },
      async actualizarPlanDesplazamiento(
        id,
        idPlanDesplazamiento,
        modoSinConexion,
      ) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === idPlanDesplazamiento)
            : -1;
          if (index !== -1) {
            registros[index].conductor.idAptitudFisica = id;
            await localforage.setItem(
              colecciones.localforage.seguridadVial.planesDesplazamientos
                .registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .registros,
              idPlanDesplazamiento,
            ),
            {
              "conductor.idAptitudFisica": id,
              "registro.estado": "Editado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async eliminar(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.aptitudes.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === id)
            : -1;
          if (index !== -1) {
            registros.splice(index, 1);
            await localforage.setItem(
              colecciones.localforage.seguridadVial.aptitudes.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.aptitudes.registros,
              id,
            ),
            {
              "registro.estado": "Eliminado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async obtener(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.aptitudes.registros,
          );
          return registros
            ? registros.find((item) => item.id === id)
            : null;
        } else {
          const q = query(
            collection(
              db,
              colecciones.firebase.seguridadVial.aptitudes.registros,
            ),
            where("id", "==", id),
            where("registro.estado", "in", ["Creado", "Editado"]),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs[0].data()
            : null;
        }
      },
      async generarID() {
        const refAptitud = doc(
          collection(
            db,
            colecciones.firebase.seguridadVial.aptitudes.registros,
          ),
        );
        return refAptitud.id;
      },
      descargarExcel(rows, nombre) {
        /* INICIALIZAR LIBRERIA */
        const XLSX = require("sheetjs-style");

        /* CREAR LIBRO */
        const wb = XLSX.utils.book_new();

        /* SEPARAR LOS REGISTROS CON Y SIN "CAMPOS.FORMATO.NOMBRE" */
        const registrosConFormato = rows.filter(
          (row) => row.campos?.formato?.nombre,
        );
        const registrosSinFormato = rows.filter(
          (row) => !row.campos?.formato?.nombre,
        );

        /* ESTILOS GENERALES DE CABERCERAS */
        const mergeHeaderStyle = {
          font: {
            bold: true,
            sz: 12,
            name: "Calibri",
            color: { rgb: "F3F3F3" },
          },
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
          fill: { fgColor: { rgb: "073d7a" } },
          border: {
            top: { style: "thin", color: { rgb: "FFFFFF" } },
            bottom: { style: "thin", color: { rgb: "FFFFFF" } },
            left: { style: "thin", color: { rgb: "FFFFFF" } },
            right: { style: "thin", color: { rgb: "FFFFFF" } },
          },
        };

        /* ESTILOS GENERALES DE CELDAS */
        const dataCellStyle = {
          border: {
            top: { style: "thin", color: 1 },
            bottom: { style: "thin", color: 1 },
            left: { style: "thin", color: 1 },
            right: { style: "thin", color: 1 },
          },
          font: {
            name: "Arial",
            sz: 10,
            bold: false,
          },
          alignment: {
            horizontal: "center",
          },
        };

        /* AGRUPAR REGISTROS CON FORMATO */
        const groupedData = _.groupBy(
          registrosConFormato,
          "campos.formato.nombre",
        );

        /* GENERAR HOJAS DE REGISTROS CON FORMATO */
        Object.entries(groupedData).forEach(([groupName, groupRows]) => {
          // DEFINIR NOMBRE DE LA HOJA (máximo 31 caracteres)
          const sheetName =
            groupName.length > 31 ? groupName.slice(0, 31) : groupName;

          /* GENERAR CABECERAS DINÁMICAS */
          const dynamicHeaders = [
            ...new Set(
              groupRows.flatMap(
                (item) =>
                  item.campos?.items?.map((campo) => campo.nombre) || [],
              ),
            ),
          ];
          const n = dynamicHeaders.length; // cantidad de campos dinámicos

          /* DEFINCIÓN DE ENCABEZADOS */

          /* CALCULAR LA CANTIDAD DE COLUMNAS EN EL GRUPO */
          const groupColCount = 7 + 2 * n;

          /* NIVEL 1 - ENCABEZADOS DE GRUPO */
          const headerRow1 = [
            "FECHA",
            "REGISTRO",
            "RESULTADO",
            "REALIZADA POR",
            "CONDUCTOR",
            "FORMATO DE APTITUD FÍSICA",
            ...Array(groupColCount - 1).fill(""),
          ];

          /* NIVEL 2 - SUBENCABEZADOS EN GRUPO */
          const headerRow2 = [
            "",
            "",
            "",
            "",
            "",
            "TOTAL SÍ",
            "TOTAL NO",
            "TOTAL BUENO",
            "TOTAL MALO",
            "TOTAL REGULAR",
            "TOTAL N/A",
            "TOTAL NO REGISTRA",
            ...dynamicHeaders.flatMap((header) => [header, ""]),
          ];

          /* NIVEL 3 - SOLO PARA EL GRUPO DINAMICO DONDE SE COLOCAN LAS COLUMNAS VALOR Y OBSERVACIÓN  */
          const headerRow3 = [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            ...dynamicHeaders.flatMap(() => ["VALOR", "OBSERVACIÓN"]),
          ];

          /* UNIR CABECERAS */
          const headers = [headerRow1, headerRow2, headerRow3];

          /* AÑADIR CABECERAS A LA HOJA */
          const ws = XLSX.utils.aoa_to_sheet(headers);

          /* CONFIGURAR UNIONES DE CELDAS */
          const merges = [];

          /* GRUPO DE COLUMNAS DE LA 1 A 5 */
          for (let c = 0; c < 5; c++) {
            merges.push({ s: { r: 0, c }, e: { r: 2, c } });
          }

          /* COLUMNA DE FORMATO DE INSPECCIÓN */
          merges.push({
            s: { r: 0, c: 5 },
            e: { r: 0, c: 5 + groupColCount - 1 },
          });

          /* COLUMNAS DE LOS TOTALES DEL FORMATO DE INSPECCIÓN */
          for (let c = 5; c < 12; c++) {
            merges.push({ s: { r: 1, c }, e: { r: 2, c } });
          }

          /* COLUMNAS DINAMICAS DEL FORMATO DE INSPECCIÓN */
          const dynamicStart = 12;
          for (let i = 0; i < n; i++) {
            merges.push({
              s: { r: 1, c: dynamicStart + i * 2 },
              e: { r: 1, c: dynamicStart + i * 2 + 1 },
            });
          }
          ws["!merges"] = merges;

          /* CONFIGURAR LOS DATOS */
          const jsonData = groupRows.map((item) => {
            const { fecha, registro, resultado, realizadaPor, conductor } =
              item;

            /* ESTRUCTURAR LAS PROPIEDADES DE VALOR Y OBSERVACIÓN */
            const dynamicValues = {};
            item.campos?.items?.forEach((campo) => {
              dynamicValues[`${campo.nombre}_valor`] = campo.valor || "-";
              dynamicValues[`${campo.nombre}_observacion`] =
                campo.observacion || "-";
              dynamicValues[`${campo.nombre}_criterio`] =
                campo.criterio || "-";
            });

            return {
              fecha,
              registro,
              resultado: resultado,
              realizadaPor,
              conductor: conductor.nombre,
              totalSi: item.campos?.totales?.totalSi || 0,
              totalNo: item.campos?.totales?.totalNo || 0,
              totalBueno: item.campos?.totales?.totalBueno || 0,
              totalMalo: item.campos?.totales?.totalMalo || 0,
              totalRegular: item.campos?.totales?.totalRegular || 0,
              totalNA: item.campos?.totales?.totalNA || 0,
              totalNoRegistra: item.campos?.totales?.totalNoRegistra || 0,
              ...dynamicValues,
            };
          });

          /* DEFINIR ORDEN DE CAMPOS PARA JSON */
          const jsonHeaders = [
            "fecha",
            "registro",
            "resultado",
            "realizadaPor",
            "conductor",
            "totalSi",
            "totalNo",
            "totalBueno",
            "totalMalo",
            "totalRegular",
            "totalNA",
            "totalNoRegistra",
            ...dynamicHeaders.flatMap((header) => [
              `${header}_valor`,
              `${header}_observacion`,
            ]),
          ];

          /* AÑADIR DATOS Y CABECERAS */
          const jsonDataClean = jsonData.map((row) => {
            const cleanRow = {};
            Object.keys(row).forEach((key) => {
              if (!key.endsWith("_criterio")) {
                cleanRow[key] = row[key];
              }
            });
            return cleanRow;
          });

          // 3. Agregar los datos a la hoja usando la versión limpia
          XLSX.utils.sheet_add_json(ws, jsonDataClean, {
            origin: "A4",
            header: jsonHeaders,
            skipHeader: true,
          });

          /* DEFINIR ANCHO DE LAS COLUMNAS */
          ws["!cols"] = [
            { wch: 15 }, // FECHA
            { wch: 20 }, // REGISTRO
            { wch: 25 }, // RESULTADO
            { wch: 40 }, // REALIZADA POR
            { wch: 40 }, // CONDUCTOR
            { wch: 20 }, // TOTAL SÍ
            { wch: 20 }, // TOTAL NO
            { wch: 20 }, // TOTAL BUENO
            { wch: 20 }, // TOTAL MALO
            { wch: 20 }, // TOTAL REGULAR
            { wch: 20 }, // TOTAL N/A
            { wch: 20 }, // TOTAL NO REGISTRA
          ].concat(
            dynamicHeaders.flatMap(() => [{ wch: 30 }, { wch: 60 }]),
          );

          /* ESTILOS PARA RESULTADOS DE INSPECCIÓN */
          const stylesByAptitudResult = {
            Apto: {
              fill: { fgColor: { rgb: "208454" } },
              font: { bold: true, color: { rgb: "FFFFFFFF" } },
            },
            "Con Control Específico": {
              fill: { fgColor: { rgb: "FFFFFF00" } },
              font: { bold: true },
            },
            "No Apto": {
              fill: { fgColor: { rgb: "E6423C" } },
              font: { bold: true, color: { rgb: "FFFFFFFF" } },
            },
          };

          /* ASIGNAR ESTILOS A CABECERAS */
          for (let r = 0; r < headers.length; r++) {
            for (let c = 0; c < headers[0].length; c++) {
              const cellRef = XLSX.utils.encode_cell({ r, c });
              if (!ws[cellRef]) ws[cellRef] = { t: "s", v: "" };
              ws[cellRef].s = mergeHeaderStyle;
            }
          }

          /* ESTILOS PARA CAMPOS DEL FORMATO */
          const valueStyles = {
            Apto: {
              fill: { fgColor: { rgb: "208454" } },
              font: { bold: true, color: { rgb: "FFFFFFFF" } },
            },
            "Con Control Específico": {
              fill: { fgColor: { rgb: "FFFFFF00" } },
              font: { bold: true },
            },
            "No Apto": {
              fill: { fgColor: { rgb: "E6423C" } },
              font: { bold: true, color: { rgb: "FFFFFFFF" } },
            },
            "N/A": {
              fill: { fgColor: { rgb: "BFBFBF" } },
              font: { color: { rgb: "000000" }, bold: true },
            },
            "No Registra": {
              fill: { fgColor: { rgb: "E6423C" } },
              font: { color: { rgb: "FFFFFF" }, bold: true },
            },
          };

          /* ASIGNAR ESTILOS A CELDAS */
          jsonData.forEach((rowData, rowIndex) => {
            const excelRowIndex = rowIndex + 3;
            jsonHeaders.forEach((header, colIndex) => {
              const cellRef = XLSX.utils.encode_cell({
                r: excelRowIndex,
                c: colIndex,
              });
              let cellStyle = { ...dataCellStyle };
              let cellValue = rowData[header];
              if (header.endsWith("_valor")) {
                const baseHeader = header.replace(/_valor$/, "");
                if (dynamicHeaders.includes(baseHeader)) {
                  if (cellValue === "N/A" || cellValue === "No Registra") {
                    cellStyle = { ...cellStyle, ...valueStyles[cellValue] };
                  } else {
                    const criterio = rowData[`${baseHeader}_criterio`];
                    if (criterio && valueStyles[criterio]) {
                      cellStyle = {
                        ...cellStyle,
                        ...valueStyles[criterio],
                      };
                    } else {
                      cellStyle = {
                        ...cellStyle,
                        ...valueStyles[cellValue],
                      };
                    }
                  }
                }
              }
              if (header === "resultado") {
                const aptitudeResult = rowData[header];
                const resultStyle = stylesByAptitudResult[aptitudeResult];
                if (resultStyle) {
                  cellStyle = { ...cellStyle, ...resultStyle };
                }
              }
              if (ws[cellRef]) {
                ws[cellRef].s = cellStyle;
              }
            });
          });

          /* AGREGAR HOJA AL WORKBOOK */
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        /* GENERAR HOJAS DE REGISTROS SIN FORMATO */
        if (registrosSinFormato.length > 0) {
          /* DEFINIR NOMBRE A LA HOJA */
          const sheetName = "APTITUDES NO REGISTRADAS";

          /* DEFINIR CABECERAS DE LA HOJA */
          const headers = [["FECHA", "CONDUCTOR"]];

          /* AÑADIR CABECERAS A LA HOJA */
          const ws = XLSX.utils.aoa_to_sheet(headers);

          /* CONFIGURACIÓN DE LOS DATOS  */
          const jsonData = registrosSinFormato.map((item) => {
            return {
              fecha: item.fecha,
              conductor: item.conductor.nombre,
            };
          });

          /* DEFINIR CABECERAS PARA JSON */
          const jsonHeaders = ["fecha", "conductor"];

          /* AÑADIR DATOS Y CABECERAS */
          XLSX.utils.sheet_add_json(ws, jsonData, {
            origin: "A2",
            header: jsonHeaders,
            skipHeader: true,
          });

          /* ASIGNAR ESTILOS A CABECERAS */
          for (let R = 0; R < headers.length; ++R) {
            for (let C = 0; C < headers[R].length; ++C) {
              const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
              if (!ws[cell_ref]) ws[cell_ref] = { t: "s", v: "" };
              ws[cell_ref].s = mergeHeaderStyle;
            }
          }

          /* ASIGNAR ESTILOS A CELDAS */
          jsonData.forEach((rowData, rowIndex) => {
            const excelRowIndex = rowIndex + 1;
            jsonHeaders.forEach((header, colIndex) => {
              const cellRef = XLSX.utils.encode_cell({
                r: excelRowIndex,
                c: colIndex,
              });
              let cellStyle = { ...dataCellStyle };
              let cellValue = rowData[header];
              if (ws[cellRef]) {
                ws[cellRef].s = cellStyle;
              }
            });
          });

          /* DETERMINAR ANCHO DE LAS CELDAS */
          ws["!cols"] = [{ wch: 15 }, { wch: 40 }];

          /* AGREGAR HOJA AL ARCHIVO PRINCIPAL */
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
        }

        /* GENERAR ARCHIVO */
        XLSX.writeFile(wb, `${nombre ? nombre : "Aptitudes Físicas"}.xlsx`);
      },
    },
  },
};
